export default {
  tabs: {
    profile: 'Profil',
    branding: 'Branding',
    domain: 'Domena',
    earning: 'Zarobki',
    feature_flags: 'Flagi funkcji',
    notification_channels: 'Kanały powiadomień',
    pricing: 'Cennik',
    fees: 'Opłaty',
    payments: 'Płatności',
    billing: 'Rozliczenia',
  },
  earning: {
    internal_notice: 'Ustawienia tylko dla FoodAmigos. Niewidoczne dla partnera.',
    read_only_notice: 'Tylko do odczytu. Kliknij Edytuj, aby zmienić wartość.',
    editing_notice: 'Edycja — zmiany wpływają na rzeczywiste obliczenia wypłat.',
  },
  fees: {
    internal_notice:
      'Ustawienia wyłącznie dla FoodAmigos. Niewidoczne dla partnera, a tę zakładkę mogą otworzyć tylko superadministratorzy. Zmiany wpływają na to, ile płacą goście i ile zarabia platforma.',
    read_only_notice: 'Tylko do odczytu. Kliknij Edytuj, aby zmienić dowolną wartość na tej karcie.',
    editing_notice:
      'Edycja — Zapisz zapisuje zarówno opłatę serwisową, jak i stawki przetwarzania. Stawki obowiązują od następnego obciążenia; wcześniejsze transakcje zachowują zarejestrowaną dla nich marżę.',
  },
  profile: {
    read_only_notice: 'Tylko do odczytu. Kliknij Edytuj, aby zmienić wartość.',
    editing_notice: 'Edycja — nazwa wyświetlana jest widoczna dla klientów.',
    form: {
      name: {
        label: 'Nazwa partnera',
        hint: 'Nazwa prawna / podmiotu. Używana wewnętrznie i w dokumentach rozliczeniowych.',
      },
      display_name: {
        label: 'Nazwa widoczna dla klientów',
        hint: 'Etykieta „Powered by ___" widoczna dla klientów. Domyślnie przyjmuje nazwę partnera.',
      },
      admin_email: {
        label: 'E-mail admina',
        hint: 'Konto zaproszonego admina. Nie można tu zmienić — skontaktuj się z działem technicznym.',
      },
      invoicing_emails: {
        label: 'E-maile z fakturami',
        hint: 'Potwierdzenia dla faktur wystawionych na tego partnera są wysyłane na każdy z tych adresów. Pozostaw puste, aby użyć e-maila administratora.',
        placeholder: 'E-mail admina',
      },
      status: {
        label: 'Status',
        hint: 'Zaproszeni partnerzy stają się aktywni przy pierwszym logowaniu — ręczna aktywacja to pomija. Zawieszenie dezaktywuje wszystkie logowania zespołu partnera.',
      },
      region: {
        label: 'Region',
        hint: 'Kraj jest stały. Wybierz stan, gdy restauracje partnera stosują podatki na poziomie stanu — zmienia to tylko domyślne ustawienia partnera, nie istniejących restauracji.',
      },
      messenger_audience: {
        label: 'Czat wsparcia',
        hint: 'Kto w ramach tego partnera ma dostęp do czatu wsparcia FoodAmigos. Pracownicy FoodAmigos mają go zawsze. Partnerzy white-label obsługują własne restauracje, więc dostęp mają tylko ich administratorzy.',
        options: {
          everyone: 'Wszyscy, łącznie z restauracjami',
          partner_admins: 'Tylko administratorzy partnera',
          nobody: 'Nikt',
        },
      },
      shop_domains: {
        label: 'Domeny sklepu',
        hint: 'Domeny główne, na których działają sklepy restauracji partnera. Domena podstawowa jest używana dla nowych marek. Partner sam podłącza i odłącza własne domeny sklepu; karta Domena pokazuje ich rekordy DNS.',
      },
    },
    region: {
      whole_country: 'Cały kraj',
    },
    shop_domains: {
      primary: 'Podstawowa',
      platform_default: 'Domyślna platformy',
      empty: 'Brak powiązanej domeny sklepu',
    },
    statuses: {
      invited: 'Zaproszony',
      active: 'Aktywny',
      suspended: 'Zawieszony',
    },
    custody: {
      label: 'Przetwarzanie płatności',
      not_configured: 'Jeszcze nie skonfigurowano',
      provider: 'Własna bramka partnera',
      platform: 'FoodAmigos przetwarza płatności',
      bank_account: {
        set: 'Konto bankowe: {{label}} ({{status}})',
        missing: 'Brak konta bankowego. Partner wprowadza je w sekcji Rozliczenia partnera.',
        statuses: {
          active: 'aktywne',
          pending_verification: 'w trakcie weryfikacji',
          action_needed: 'wymagane działanie',
          errored: 'wypłata nie powiodła się',
          missing: 'brak',
        },
      },
      hint: 'Decyduje o tym konfiguracja płatności w zakładce Płatności i jest blokowana po zapisaniu kanału. Przy rozliczeniach przez FoodAmigos udział partnera w przychodach jest wypłacany co miesiąc.',
      kyc: {
        label: 'Konto wypłat',
        missing: 'Jeszcze nie utworzono',
        incomplete: 'Weryfikacja niekompletna',
        complete: 'Gotowe do wypłat',
        currently_due: 'Stripe wciąż wymaga: {{fields}}',
        send_link: 'Wyślij link do onboardingu',
        link_copied: 'Link do onboardingu skopiowany do schowka — prześlij go partnerowi. Jest jednorazowy i wygasa.',
        link_ready: 'Link do onboardingu — prześlij go partnerowi (jednorazowy, wygasa)',
        link_failed: 'Nie udało się utworzyć linku do onboardingu.',
      },
    },
    suspend_confirm: {
      title: 'Zawiesić tego partnera?',
      description:
        'Wszyscy członkowie zespołu partnera zostaną dezaktywowani, a ich sesje unieważnione. Restauracje pozostają aktywne.',
    },
  },
  branding: {
    read_only_notice: 'Tylko do odczytu. Kliknij Edytuj, aby zmienić wartość.',
    editing_notice: 'Edycja — zmiany są widoczne na powierzchniach white-label partnera.',
    upload: 'Prześlij logo',
    logo: {
      label: 'Logo',
      hint: 'Wyświetlane na powierzchniach white-label partnera.',
    },
    circle_logo: {
      label: 'Favicon / logo okrągłe',
      hint: 'Kwadratowe logo używane jako favicon i awatar. Opcjonalne — można usunąć.',
    },
    splash_image: {
      label: 'Grafika logowania',
      hint: 'Wypełnia lewą połowę strony logowania white-label partnera od krawędzi do krawędzi (kadrowanie cover). Zalecane: kompozycja pionowa, min. 1200×1200px. Opcjonalne — można usunąć.',
    },
    footer_note: 'Więcej opcji brandingu (kolory drugorzędne) pojawi się wkrótce.',
  },
  revenue_split: {
    title: 'Podział przychodów',
    description:
      'Ustaw udział partnera w każdej opłacie pobieranej przez FoodAmigos z zamówień jego restauracji. Domyślnie 0% — FoodAmigos zatrzymuje pełną opłatę do czasu przyznania udziału. Wypłacane co cykl rozliczeniowy.',
    manage_on_fees: 'Zarządzaj w zakładce Opłaty',
    split: 'Partner {{partner}}% · FoodAmigos {{platform}}%',
    rows: {
      processing: 'Opłaty processingowe',
      gift_card: 'Opłata za kartę podarunkową',
      delivery: 'Opłaty za dostawę',
      service_fee: 'Opłata serwisowa',
    },
    notes: {
      service_fee:
        'Kwota pobierana od klientów jest ustawiana w sekcji Ustawienia opłaty serwisowej w zakładce Opłaty.',
    },
  },
  service_fee_controls: {
    title: 'Kontrola opłaty serwisowej',
    description: 'Kwota, którą partner pobiera od gości jako opłatę serwisową do zamówienia.',
    zero_percentage_warning:
      '0% nie wyłącza opłaty serwisowej: obliczone opłaty poniżej minimum są zaokrąglane w górę, więc każde zamówienie jest obciążane co najmniej kwotą minimalną.',
  },
  hard_limits: {
    title: 'Twarde limity',
    description:
      'Limity FoodAmigos egzekwowane przy zapisie i płatności. Żadna opłata serwisowa tego partnera — w tym nadpisania per restauracja — nie może ich przekroczyć.',
    max_percentage: {
      label: 'Maksymalny % opłaty serwisowej',
      help: 'Opłata serwisowa partnera nie może przekroczyć tej wartości. Limit platformy: 5%.',
    },
    min_amount: {
      label: 'Minimalna kwota opłaty serwisowej',
      help: 'Minima per restauracja nie mogą być niższe niż ta kwota.',
    },
    max_amount: {
      label: 'Maksymalna kwota opłaty serwisowej',
      help: 'Bezwzględny limit stałej opłaty serwisowej, niezależnie od procentu.',
    },
  },
  form: {
    charges_service_fee_on_site: {
      label: 'Pobieraj opłatę serwisową od zamówień przy stolikach',
      description:
        'Domyślnie dla restauracji tego partnera; każda może ustawić własne. Wyłączone: zamówienia przy stolikach nie płacą opłaty serwisowej.',
    },
    is_service_fee_change_allowed: {
      label: 'Zezwól na zmianę opłaty serwisowej per restauracja',
      description: 'Pozwala poszczególnym restauracjom partnera używać innej opłaty serwisowej.',
    },
    service_fee_platform_share: {
      label: 'Udział Foodamigos w opłacie serwisowej',
    },
    recommended: 'Zalecane: {{value}}',
    service_fee_percentage: {
      label: 'Domyślny % opłaty serwisowej',
      help: 'Stosowany do każdej restauracji partnera, chyba że nadpisany.',
    },
    min_service_fee_amount: {
      label: 'Domyślna minimalna kwota opłaty',
      help: 'Domyślne minimum na zamówienie — obliczone opłaty poniżej są zaokrąglane w górę. Restauracje mogą ustawić własne w ramach limitów FoodAmigos.',
    },
    max_service_fee_amount: {
      label: 'Domyślna maksymalna kwota opłaty',
      help: 'Domyślny limit na zamówienie — restauracje mogą ustawić własny w ramach limitów FoodAmigos.',
    },
    primary_color: {
      label: 'Główny kolor marki',
    },
    dashboard_subdomain: {
      label: 'Slug logowania partnera',
      hint: 'Slug małymi literami — identyfikuje markę partnera w linku do logowania zespołu (?partner=…).',
      placeholder: 'partner-name',
    },
    login_url: {
      label: 'Link do logowania zespołu',
      hint: 'Link, którego zespół partnera używa do dostępu do strony logowania z marką.',
    },
    file: {
      label: 'Grafika',
    },
  },
  buttons: {
    edit: 'Edytuj',
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  toasts: {
    load_error: 'Nie można załadować ustawień.',
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
    logo_uploaded: 'Logo przesłane',
    logo_upload_failed: 'Nie udało się przesłać logo',
    logo_removed: 'Logo usunięte',
    logo_remove_failed: 'Nie udało się usunąć logo',
    file_too_large: 'Plik jest za duży. Maksymalny rozmiar to {{max}} MB.',
    image_too_narrow: 'Grafika logowania musi mieć co najmniej {{min}}px szerokości.',
  },
  notification_channels: {
    master_locked:
      'Partner główny wysyła do każdej restauracji na platformie, więc jego kanały nie mogą być tu zmieniane.',
    unavailable: 'Kanały powiadomień nie są jeszcze dostępne w tym backendzie.',
    notice:
      'Ustawienie wewnętrzne. Partner bez własnego konta Twilio musi korzystać wyłącznie z e-maila: w przeciwnym razie każdy SMS, wiadomość WhatsApp i połączenie głosowe byłyby wysyłane z konta Twilio FoodAmigos.',
    forbidden: 'Tylko super administratorzy mogą zmieniać kanały powiadomień.',
    columns: {
      channel: 'Kanał',
      status: 'Włączony',
    },
    channels: {
      email: {
        name: 'E-mail',
        description: 'Zawsze aktywny, dzięki czemu partner i jego restauracje są zawsze dostępne.',
      },
      sms: {
        name: 'SMS',
        description: 'Aktualizacje zamówień i kody logowania dla gości przez wiadomość tekstową.',
      },
      whatsapp: {
        name: 'WhatsApp',
        description: 'Alerty dla właścicieli restauracji i kody logowania dla gości przez WhatsApp.',
      },
      voice_call: {
        name: 'Połączenia głosowe',
        description: 'Przypomnienia telefoniczne o oczekujących zamówieniach i obsługa połączeń.',
      },
      push: {
        name: 'Powiadomienia push',
        description:
          'Powiadomienia push dla gości i aplikacji dashboardu właściciela. Nie wpływa to na alerty na tablecie personelu.',
      },
    },
    toasts: {
      load_error: 'Nie udało się wczytać kanałów powiadomień.',
      error: 'Nie udało się zapisać kanałów powiadomień.',
      saved: 'Kanały powiadomień zapisane.',
    },
  },
  feature_flags: {
    internal_notice: 'Ustawienia wyłącznie dla FoodAmigos. Niewidoczne dla partnera. Zmiany obowiązują natychmiast.',
    read_only:
      'Tylko do odczytu — zmiana rozliczeń restauracji wymaga skoordynowanego wdrożenia, nie przełącznika. Skontaktuj się z działem technicznym.',
    forbidden: 'Tylko superadministratorzy mogą zarządzać flagami funkcji partnerów.',
    columns: {
      feature: 'Funkcja',
      status: 'Status',
    },
    flags: {
      external_printer: {
        name: 'Zewnętrzna drukarka paragonów',
        description:
          'Domyślne ustawienie dla restauracji dodawanych przez tego partnera od teraz: każda nowa restauracja będzie mogła od razu podłączyć sieciową drukarkę paragonów do aplikacji terminala zamówień. Istniejące restauracje zachowują to, co ustawia ich własna zakładka Flagi funkcji, a każdą restaurację nadal można przełączyć tam indywidualnie.',
      },
      plg_onboarding: {
        name: 'Samodzielny onboarding (PLG)',
        description:
          'Samoobsługowe wdrażanie partnera: zapewnia temu partnerowi prowadzoną stronę „Nowa restauracja” i kreator onboardingu zamiast klasycznego modalu Dodaj firmę i kreatora Rozpocznij, ukrywa elementy dostępne tylko dla FoodAmigos oraz jeszcze nieodpowiednie dla partnera i jego restauracji, a także blokuje pierwsze uruchomienie do czasu ustalenia daty startu. Włączone dla każdego nowego partnera.',
      },
      issue_end_customer_receipts: {
        name: 'Faktury dla klientów końcowych',
        description:
          'Umożliwia gościom żądanie faktury przy kasie i jej otrzymanie e-mailem. Wyłączone dla nowych partnerów; międzynarodowe zasady formatowania faktur sprawiają, że wsparcie jest kosztowne.',
      },
      merchant_billing: {
        name: 'Rozliczenia restauracji',
        description: 'Rozlicza restauracje partnera przez platformę. Wyłączone oznacza rozliczenie poza nią.',
      },
      cuisine_backfill: {
        name: 'Uzupełnianie kuchni',
        description: 'Umożliwia automatyczne uzupełnianie typu kuchni dla restauracji tego partnera.',
      },
      image_backfill: {
        name: 'Uzupełnianie zdjęć',
        description: 'Umożliwia automatyczne uzupełnianie zdjęć menu dla restauracji tego partnera.',
      },
      auto_image_generation: {
        name: 'Automatyczne generowanie zdjęć',
        description: 'Generuje zdjęcia menu na żądanie dla restauracji tego partnera.',
      },
      provider_billing: {
        name: 'Rozliczenia partnera przez Foodamigos',
        description:
          'Dołącza tego partnera do cyklu rozliczeniowego Foodamigos. Wyłączenie oznacza, że partner jest fakturowany poza platformą. Włącza również PayPal (bezpośredni) dla restauracji tego partnera, z pobieraną od niego opłatą serwisową.',
      },
      partner_custom_dashboard_domain: {
        name: 'Własna domena panelu',
        description:
          'Umożliwia temu partnerowi podłączenie własnej domeny panelu, dzięki czemu jego zespół i restauracje logują się pod adresem partnera. Włączenie lub wyłączenie tej opcji zmienia każdy link do panelu wysyłany przez platformę temu partnerowi.',
      },
      partner_custom_shop_domain: {
        name: 'Własna domena sklepu',
        description:
          'Pozwala temu partnerowi podłączyć własną domenę dla sklepów internetowych jego restauracji, w której każda restauracja otrzymuje własny adres. Włączać pojedynczo dla każdego partnera: zmienia adres, którego używają klienci.',
      },
      partner_legal_documents: {
        name: 'Dokumenty prawne partnera',
        description:
          'Generuje impressum, politykę prywatności i regulamin dla lokali gastronomicznych tego partnera na podstawie danych prawnych każdej restauracji. Wyłączone, lub gdy dane restauracji są niekompletne, lokale wyświetlają standardowe dokumenty platformy.',
      },
    },
    toasts: {
      load_error: 'Nie udało się załadować flag funkcji',
      error: 'Nie udało się zmienić flagi funkcji',
      enabled: 'Funkcja włączona',
      disabled: 'Funkcja wyłączona',
    },
  },
};
